import { SupportedLocale } from "../config/locales";

/**
 * Names a *content* locale in the interface language: the Estonian tab reads
 * "Estonian" for an English admin and "эстонский" for a Russian one.
 *
 * A label spelled out in `REACT_APP_SUPPORTED_LOCALES` (`et:Eesti`) is a
 * deliberate choice by whoever configured the deploy target and wins over the
 * derived name.
 */
export function contentLocaleLabel(locale: SupportedLocale, uiLanguage: string): string {
    if (locale.configuredLabel != null && locale.configuredLabel.length > 0) {
        return locale.configuredLabel;
    }

    try {
        const resolved = new Intl.DisplayNames([uiLanguage], { type: "language" }).of(locale.code);
        if (resolved != null && resolved.toLowerCase() !== locale.code.toLowerCase()) {
            return resolved;
        }
    } catch {
        // Intl.DisplayNames unavailable, or an unrecognised code — fall through
        // to whatever `config/locales` already resolved.
    }

    return locale.label;
}
